import { render, staticRenderFns } from "./RsaPazienteParametriVitaliListPage.vue?vue&type=template&id=77ca9002"
import script from "./RsaPazienteParametriVitaliListPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteParametriVitaliListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports